import {create} from "zustand";

type PanicIntentState = {
  intentToken: string | null;
  expiresAt: string | null;
  confirmationWindowSeconds: number | null;
  alertId: number | null;
  setIntent: (data: {
    intentToken: string;
    expiresAt: string;
    confirmationWindowSeconds: number;
    alertId: number;
  }) => void;
  clearIntent: () => void;
};

export const usePanicIntentStore = create<PanicIntentState>((set) => ({
  intentToken: null,
  expiresAt: null,
  confirmationWindowSeconds: null,
  alertId: null,
  setIntent: ({intentToken, expiresAt, confirmationWindowSeconds, alertId}) =>
    set({
      intentToken,
      expiresAt,
      confirmationWindowSeconds,
      alertId,
    }),
  clearIntent: () =>
    set({
      intentToken: null,
      expiresAt: null,
      confirmationWindowSeconds: null,
      alertId: null,
    }),
}));

export function useStoredPanicIntent() {
  return usePanicIntentStore((state) => state);
}

export function useStoredPanicIntentToken() {
  return usePanicIntentStore((state) => state.intentToken);
}

export function useStoredPanicIntentExpiresAt() {
  return usePanicIntentStore((state) => state.expiresAt);
}

export function useSetPanicIntent() {
  return usePanicIntentStore((state) => state.setIntent);
}

export function useClearPanicIntent() {
  return usePanicIntentStore((state) => state.clearIntent);
}
